<template>
  <div
    v-if="!isFarEastMarket && !isOnDemand && product.status"
    class="product__price"
  >
    <div v-if="priceRangeToConsider">
      <span class="product__price__text" v-if="regularPrice > 0">
        {{ `✺ ${$t('total')} ` }}
      </span>
      <span class="product__price__special" v-if="specialPriceActive">
        {{ $fc(finalPrice) }}
      </span>
      <span
        v-if="regularPrice > 0"
        class="product__price__regular"
        :class="specialPriceActive && 'product__price__regular--barred'"
      >
        {{ $fc(regularPrice) }}
      </span>
      <span v-else class="product__price__regular">
        {{ `✺ ${$t('request a price quote')}` }}
      </span>
    </div>
  </div>
</template>

<script>
import { defineComponent, computed } from '@nuxtjs/composition-api';
import { useMarkets } from '~/composables';

export default defineComponent({
  name: 'ProductPrice',
  components: {},
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const { isFarEastMarket } = useMarkets();

    const selectedVariant = computed(
      () => props.product?.configurable_product_options_selection?.variant
    );

    const isOnDemand = computed(
      () =>
        props.product?.configurable_product_options_selection?.variant
          ?.sdc_ondemand
    );

    const priceRangeToConsider = computed(() =>
      selectedVariant.value
        ? selectedVariant.value.price_range
        : props.product?.price_range
    );
    const regularPrice = computed(
      () => priceRangeToConsider.value?.minimum_price?.regular_price?.value
    );
    const finalPrice = computed(
      () => priceRangeToConsider.value?.minimum_price?.final_price?.value
    );
    const specialPriceActive = computed(
      () =>
        priceRangeToConsider.value?.minimum_price?.final_price?.value <
        priceRangeToConsider.value?.minimum_price?.regular_price?.value
    );
    return {
      regularPrice,
      finalPrice,
      specialPriceActive,
      priceRangeToConsider,
      isFarEastMarket,
      isOnDemand,
    };
  },
});
</script>

<style lang="scss" scoped>
.product__price {
  width: 100%;
  display: flex;
  justify-content: space-between;
  &__regular,
  &__special,
  &_customizable {
    @include paragraph-m;
  }
  &__regular {
    &--barred {
      text-decoration: line-through;
      color: var(--c-dark-gray);
    }
  }
}
</style>
